var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/lib/CircularProgress.tsx
import { useEffect, useState } from "react";
import {
  default as MuiCircularProgress
} from "@mui/material/CircularProgress";
import Stack from "@mui/material/Stack";
import { SuccessCircleIcon, WarningCircleIcon } from "@availity/mui-icon";
import { Typography } from "@availity/mui-typography";
import { jsx, jsxs } from "react/jsx-runtime";
var StatusIcon = ({ status, size }) => {
  const fontSize = size === "small" ? "medium" : "large";
  switch (status) {
    case "error":
      return /* @__PURE__ */ jsx(WarningCircleIcon, { color: "error", fontSize, titleAccess: "loading error" });
    case "success":
      return /* @__PURE__ */ jsx(SuccessCircleIcon, { color: "success", fontSize, titleAccess: "loading successful" });
    default:
      return null;
  }
};
var getCaptionText = (status) => ({
  loading: "Loading",
  error: "Loading error",
  success: "Loading successful"
})[status] || "";
var CircularProgress = (_a) => {
  var _b = _a, {
    loadingCaption = true,
    error = false,
    success = false,
    size = "default"
  } = _b, props = __objRest(_b, [
    "loadingCaption",
    "error",
    "success",
    "size"
  ]);
  const [status, setStatus] = useState("loading");
  useEffect(() => {
    if (error) {
      setStatus("error");
    } else if (success) {
      setStatus("success");
    } else {
      setStatus("loading");
    }
  }, [error, success]);
  return /* @__PURE__ */ jsxs(Stack, { sx: { width: "fit-content", alignItems: "center" }, children: [
    status === "loading" ? /* @__PURE__ */ jsx(
      MuiCircularProgress,
      __spreadProps(__spreadValues({
        "aria-label": "Loading"
      }, props), {
        size: size === "small" ? 24 : 40,
        variant: "indeterminate"
      })
    ) : /* @__PURE__ */ jsx(StatusIcon, { status, size }),
    /* @__PURE__ */ jsx(Typography, { sx: { marginTop: "8px" }, variant: "caption", children: loadingCaption || error || success ? getCaptionText(status) : null })
  ] });
};

// src/lib/LinearProgress.tsx
import { SuccessCircleIcon as SuccessCircleIcon2 } from "@availity/mui-icon";

// ../layout/src/lib/Box.tsx
import { forwardRef } from "react";
import MuiBox from "@mui/material/Box";
import { jsx as jsx2 } from "react/jsx-runtime";
var Box = forwardRef((props, ref) => {
  return /* @__PURE__ */ jsx2(MuiBox, __spreadProps(__spreadValues({}, props), { ref }));
});

// ../layout/src/lib/Container.tsx
import MuiContainer from "@mui/material/Container";
import { jsx as jsx3 } from "react/jsx-runtime";

// ../layout/src/lib/Grid.tsx
import MuiGrid2 from "@mui/material/Grid2";
import { jsx as jsx4 } from "react/jsx-runtime";

// ../layout/src/lib/Stack.tsx
import MuiStack from "@mui/material/Stack";
import { jsx as jsx5 } from "react/jsx-runtime";
var Stack2 = (_a) => {
  var _b = _a, { children } = _b, rest = __objRest(_b, ["children"]);
  return /* @__PURE__ */ jsx5(MuiStack, __spreadProps(__spreadValues({}, rest), { children }));
};

// src/lib/LinearProgress.tsx
import { Typography as Typography2 } from "@availity/mui-typography";
import MuiLinearProgress from "@mui/material/LinearProgress";
import { jsx as jsx6, jsxs as jsxs2 } from "react/jsx-runtime";
var LinearProgress = (_a) => {
  var _b = _a, { variant = "determinate", value = 0, sx, hidePercentage = false } = _b, props = __objRest(_b, ["variant", "value", "sx", "hidePercentage"]);
  return /* @__PURE__ */ jsxs2(Stack2, { direction: "row", sx: { alignItems: "center" }, children: [
    /* @__PURE__ */ jsx6(Box, { sx: { width: "100%", mr: 0.5 }, children: /* @__PURE__ */ jsx6(MuiLinearProgress, __spreadProps(__spreadValues({ variant }, props), { value, color: "success", sx: __spreadValues({ width: "100%" }, sx) })) }),
    value === 100 && /* @__PURE__ */ jsx6(SuccessCircleIcon2, { color: "success", "data-icon": "complete" }),
    !hidePercentage && /* @__PURE__ */ jsx6(Typography2, { variant: "body2", sx: { color: "text.secondary", ml: 1 }, children: `${Math.round(value)}%` })
  ] });
};
export {
  CircularProgress,
  LinearProgress
};
